import React from 'react';

export const Label = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <label
    ref={ref}
    className={`text-sm font-medium text-gray-700 block ${className}`}
    {...props}
  >
    {children}
  </label>
));

Label.displayName = 'Label';
